export default function (to: any) {
    useBodyClasses().areaName(to.meta.area);
}
